// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d02a2842","703":"fd6ed378","787":"be4c4e0f"}[chunkId] + ".chunk.js";
};